/**
 * Helper i18n para la etiqueta de superficie recomendada (v16.3 §4).
 *
 * El backend serializa `recommended_surface` como string opaco con valores
 * canónicos definidos en `services/training_engine/surface_recommendation.py`.
 * Este helper traduce el valor canónico a label visible en español.
 *
 * Por qué string opaco y no enum: el set de valores es chico (5) pero
 * puede crecer sin requerir cambios coordinados de tipo TS; el switch
 * cubre los conocidos y devuelve "" para desconocidos (no rompe layout).
 */
import { t } from "@/i18n/es";

export function labelForRecommendedSurface(value: string | null): string {
  switch (value) {
    case "asfalto":
      return t.plan.surfaceLabelAsfalto;
    case "montana":
      return t.plan.surfaceLabelMontana;
    case "pista_o_asfalto":
      return t.plan.surfaceLabelPistaAsfalto;
    case "pista_o_llano":
      return t.plan.surfaceLabelPistaLlano;
    case "free":
      return t.plan.surfaceLabelFree;
    default:
      return "";
  }
}
